package app.bloomey.web.modules.library

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.Category
import app.bloomey.web.core.data.models.CategoryUpdateRequest
import app.bloomey.web.core.data.models.PageResponse
import app.bloomey.web.core.data.models.Video

object LibraryContract {
    data class State(
        val libraries: UiState<PageResponse<List<Category>>> = UiState.Initial,
        val page: Int = 1,
        val detailVideos: UiState<PageResponse<List<Video>>> = UiState.Initial,
        val detailsPage: Int = 1,
        val deleteLibrary: UiState<Boolean> = UiState.Initial,
        val updateLibrary: UiState<Boolean> = UiState.Initial,
    )

    sealed interface Inputs {
        data class GetLibraries(val page: Int, val size: Int, val query: String) : Inputs
        data class GetLibraryVideos(val libraryId: String, val page: Int, val size: Int) : Inputs
        data class DeleteLibrary(val libraryId: String) : Inputs
        data class UpdateLibrary(val libraryId: String, val request: CategoryUpdateRequest) : Inputs
        class ResetState(val property: String) : Inputs
    }

    object Events
}
